<template>
  <div
    draggable="true"
    class="route-point"
    @dragstart="onDragStart"
    @dragover.prevent="onDragOver"
    @dragend="onDragEnd"
    @drop="onDrop"
    @click="$emit('edit', point)"
  >
    <div class="route-point__drag">
      <b-iconstack font-scale="1">
        <b-icon stacked icon="three-dots-vertical" />
        <b-icon stacked icon="three-dots-vertical" shift-h="4" />
      </b-iconstack>
    </div>
    <span class="route-point__index">{{ prettyIndex }}</span>
    <div class="route-point__title">{{ placeTitle }}</div>
    <AudioPlayer v-if="audio" minimal :file="audio" class="route-point__audio" />
    <div class="table-actions">
      <button type="button" class="action-button action-edit" @click.stop="$emit('edit', point)">
        <b-icon class="action-icon" icon="pen" />
        <span>Изменить</span>
      </button>
      <button type="button" class="action-button action-delete" @click.stop="deletePoint">
        <b-icon class="action-icon" icon="trash2" />
        <span>Удалить</span>
      </button>
    </div>
  </div>
</template>

<script>
import AudioPlayer from '@/components/AudioPlayer.vue';

export default {
  name: 'RouteTimelinePoint',
  components: { AudioPlayer },
  props: {
    point: { type: Object, required: true },
    index: { type: Number, required: true },
  },
  computed: {
    prettyIndex() {
      return this.index + 1;
    },
    audio() {
      return this.point.audio_file || this.point.place.audio_file;
    },
    placeTitle() {
      return this.point?.place?.title || 'unknown';
    },
  },
  methods: {
    async deletePoint(event = undefined) {
      event?.stopPropagation();

      const userAgreed = await this.$bvModal.msgBoxConfirm(
        `Вы действительно хотите удалить точку маршрута: ${this.placeTitle}?`,
        {
          okTitle: 'Удалить',
          cancelTitle: 'Отмена',
          cancelVariant: 'outline-secondary',
        },
      );

      if (!userAgreed) {
        return;
      }

      this.$emit('delete', this.point);
    },
    onDragStart(event) {
      event.dataTransfer.setData('text/plain', String(this.point.id));
    },
    onDragOver(event) {
      event.preventDefault();
      event.dataTransfer.dropEffect = 'move';

      document.getElementById('dummy')?.remove();
      const closestBorder = this.getClosestBorder(event.clientY);
      const dummyElement = this.createDummyElement();
      if (closestBorder === 'top') {
        this.$el.parentElement.insertBefore(dummyElement, this.$el);
      } else {
        this.$el.parentElement.insertBefore(dummyElement, this.$el.nextElementSibling);
      }
    },
    getClosestBorder(clientY) {
      const { top, bottom } = this.$el.getBoundingClientRect();
      return clientY - top < bottom - clientY ? 'top' : 'bottom';
    },
    createDummyElement() {
      const dummy = document.createElement('div');
      dummy.id = 'dummy';
      dummy.style.backgroundColor = '#d40302';
      dummy.style.width = '100%';
      dummy.style.height = '5px';

      return dummy;
    },
    onDrop(event) {
      const movedPointId = Number(event.dataTransfer.getData('text/plain'));
      const dummyPlacement = this.getClosestBorder(event.clientY) === 'top' ? 'before' : 'after';
      const dropPoint = this.point;
      this.$emit('move', movedPointId, dummyPlacement, dropPoint);
      document.getElementById('dummy')?.remove();
    },
    onDragEnd() {
      document.getElementById('dummy')?.remove();
    },
  },
};
</script>

<style lang="scss" scoped>
.route-point {
  display: flex;
  min-height: 62px;
  align-items: center;
  gap: 14px;
  padding: 10px 14px;
  border-bottom: 1px solid #eaecf0;
  background: #fff;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s ease;

  &:hover {
    background: #fff8f8;

    .route-point__drag {
      opacity: 1;
    }
  }

  &__drag {
    color: #d46c6c;
    opacity: 0.45;
    transition: opacity 0.15s ease;
  }

  &__index {
    width: 28px;
    flex: 0 0 28px;
    color: #667085;
    font-weight: 700;
    text-align: center;
  }

  &__title {
    min-width: 180px;
    flex: 1;
    font-weight: 500;
  }

  &__audio {
    flex: 0 0 auto;
  }
}
</style>
